import { createRouter, createWebHistory, useRoute } from 'vue-router'
import HomeView from '@/views/home_view.vue'
import { useUserStore } from '@/store/counter';
const route = useRoute()
const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/login.vue'),
        meta: { roles: ['1', '2', '3', '4', '5','6', '9'] }
    },
    {
        path: '/weixinLogin',
        name: 'weixinLogin',
        component: () => import('../views/login/weixinLogin.vue'),
        meta: { roles: ['1', '2', '3', '4', '5','6', '9'] }
    },
    {
        path: '/',
        name: 'view',
        component: HomeView,
        meta: { roles: ['1', '2', '3', '4', '5','6', '9'] }
    },
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        meta: { roles: ['1', '2', '3', '4', '5','6', '9'] },
        // redirect: '/question_table',
        children: [
            {
                path: '/glyQuestionTable',
                name: 'glyQuestionTable',
                component: () => import('@/views/gly/question_table.vue'),
                meta: { roles: ['1', '2', '3', '4', '5','6'],keepAlive: true },
                props: true,
            },
            {
                path: '/questionEdit',
                name: 'questionEdit',
                component: () => import('@/views/gly/question_edit.vue'),
                meta: { roles: ['1', '2', '3', '4', '5','6'] ,keepAlive: true},
                props: true
                // props: route => ({ datas: route.query.datas, values: route.query.values })
            }, {
                path: '/questionSelUser',
                name: 'questionSelUser',
                component: () => import('@/views/gly/question_sel_user.vue'),
                meta: { roles: ['1', '2', '3', '4','5','6'],keepAlive: true },
                props: true
                // props: route => ({ datas: route.query.datas, values: route.query.values })
            },
            {
                path: '/htgl',
                name: 'htgl',
                component: () => import('@/views/htgl/htgl.vue'),
                meta: { roles: ['1'],keepAlive: true }
            },
            {
                path: '/tjwt',
                name: 'tjwt',
                component: () => import('@/views/gly/tjwt.vue'),
                meta: { roles: ['1', '2', '3', '4', '5','6'] ,keepAlive: true}
            },
            {
                path: '/questionTable',
                name: 'questionTable',
                component: () => import('@/views/yy/question_table.vue'),
                meta: { roles: ['9'],keepAlive: true }
            },
            {
                path: '/questionEvaluate',
                name: 'questionEvaluate',
                component: () => import('../views/yy/question_evaluate.vue'),
                meta: { roles: ['9'],keepAlive: true }
            },
            {
                path: '/questionInsert',
                name: 'questionInsert',
                component: () => import('../views/yy/question_insert.vue'),
                meta: { roles: ['9'],keepAlive: true }
            },
            {
                path: '/questionSendBack',
                name: 'questionSendBack',
                component: () => import('../views/yy/question_send_back.vue'),
                meta: { roles: ['1', '2','9'],keepAlive: true }
            },
            {
                path: '/cxtj',
                name: 'cxtj',
                component: () => import('@/views/cxtj/cxtj.vue'),
                meta: { roles: ['1', '2'],keepAlive: true }
            },
        ]
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const store = useUserStore()

    //-：获取是否登录的状态
    let isLogin = store.isLoggedIn
    //-:访问的请求不是 login，不是weixinLogin 也没有登录
    if (to.name !== 'login' && to.name !== 'weixinLogin' && !isLogin) {
        next({ name: 'login' })
    } else if (to.name == 'weixinLogin' && !isLogin) {
        next()
    } else if (to.name == 'login' && isLogin) {//-:已经登录了，还在访问登录请求
        next({ name: 'home' })
    } else {//否则，该干啥干啥
        if (to.name == 'home' || to.name == 'login' || to.name == '/' || to.name == '') {
            next()
        } else {
            if (!to.meta.roles.includes(store.userInfo.roleId)) {
                next({ name: 'home' })
            } else {
                next()
            }
        }





    }
});

export default router
